<template>
	<div class="pt-3 pb-4 d-flex flex-column h-100">
		<div class="flex-grow-1">
			<b-container>
				<b-row>
					<b-col class="align-self-center">
						<router-link to="/">
							<b-img src="/logo_white.png" fluid width="200"></b-img>
						</router-link>
					</b-col>
					<b-col class="align-self-center" cols="auto">
						<b-button v-if="!isAuthenticated" variant="primary" to="/sign-up">Sign Up</b-button>
						<b-button v-else-if="title != 'Dashboard'" variant="primary" to="/dashboard">My Dashboard</b-button>
					</b-col>
				</b-row>
			</b-container>
			<router-view />
		</div>
		<b-container class="site-footer small pb-4">
			<b-row>
				<b-col offset="0">
					<ul class="list-inline m-0">
						<li class="list-inline-item mr-3">
							<router-link to="/privacy">Privacy Policy</router-link>
						</li>
						<li class="list-inline-item">
							<router-link to="/unsubscribe">Unsubscribe</router-link>
						</li>
					</ul>
				</b-col>
				<!-- <b-col cols="auto">
					© 2020 360Trivia.com. All rights reserved.
				</b-col> -->
			</b-row>
		</b-container>
	</div>
</template>

<script>
	export default {
		name: "MainLayout",
		computed: {
			title () {
				return this.$route.meta.page.title;
			},
			isAuthenticated () {
				return this.$store.getters['auth/isAuthenticated'];
			}
		}
	}
</script>
